import { SessionSurvey } from './session-survey.model';
import { SurveyMapper } from 'app/survey/survey.mapper';
import { SURVEY_PROGRESS_STATUS } from 'app/survey/fill-out-the-questionnaire/survey-progress-status.const';

export class SessionSurveyMapper {
  public static map(sessionData: any): SessionSurvey {
    if (!sessionData) {
      return null;
    }

    return new SessionSurvey(
        SurveyMapper.map(sessionData.survey),
        sessionData.surveyStartDate ? new Date(sessionData.surveyStartDate) : null,
        sessionData.surveyEndDate ? new Date(sessionData.surveyEndDate) : null,
        sessionData.surveyStatus ? sessionData.surveyStatus : SURVEY_PROGRESS_STATUS.NOT_STARTED
      );
  }
}



// WEBPACK FOOTER //
// /dist/src/app/session/session-survey.mapper.ts